import React from 'react';
import type { IndexInstrumentViewModel, IndicesPeriod } from '@app-types/indices';
import IndicesChartPreview from './IndicesChartPreview';

interface IndexCardProps {
  instrument: IndexInstrumentViewModel;
  period: IndicesPeriod;
  onSelect: (instrument: IndexInstrumentViewModel, trigger: HTMLElement) => void;
}

// work_items_118: Page Data excludes High/Low for these RICs.
const RICS_WITHOUT_HIGH_LOW: ReadonlySet<string> = new Set([
  '.DJI',
  'US30YT=RR',
  'US10YT=RR',
  'GB10YT=RR',
  'DE10YT=RR',
  'FR10YT=RR',
]);

const IndexCard: React.FC<IndexCardProps> = ({ instrument, period, onSelect }) => {
  const supportsHighLow = !RICS_WITHOUT_HIGH_LOW.has(instrument.ric);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    onSelect(instrument, event.currentTarget);
  };

  return (
    <article
      className="index-card"
      data-instrument-id={instrument.id}
      role="button"
      tabIndex={0}
      aria-label={`${instrument.name}, ${instrument.valueText}, ${instrument.changeText}`}
      onClick={(event) => onSelect(instrument, event.currentTarget)}
      onKeyDown={handleKeyDown}
    >
      <div className="index-card__header">
        <span className="index-card__name">{instrument.name}</span>
        <span className="index-card__updated-at">{instrument.updatedAtText}</span>
      </div>
      <div className="index-card__body">
        <div className="index-card__quote">
          <span className="index-card__value">{instrument.valueText}</span>
          <span className={`index-card__change index-card__change--${instrument.changeTone}`}>
            {instrument.changeText}
          </span>
        </div>
        <div className="index-card__range">
          {supportsHighLow && (
            <>
              <span>高値&nbsp;{instrument.highText}</span>
              <span>安値&nbsp;{instrument.lowText}</span>
            </>
          )}
        </div>
        <IndicesChartPreview instrument={instrument} period={period} />
      </div>
    </article>
  );
};

export default IndexCard;
